import { NgModule, ChangeDetectionStrategy, ChangeDetectorRef,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';

import { EscapePipe } from './escape.pipe';
import { SafeHtmlPipe } from './filterHtml.pipe';
import { LoadingDirective } from './loading.directive';
import { LoaderComponent } from './loader/loader.component';

import { ErrorViewComponent } from './error-view/error-view.component';

import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileUploadService } from './file-upload/file-upload.service';

import { CommentComponent } from './comment/comment.component';
import { CommentService } from './comment/comment.service';
import { GamificationRuleComponent } from './gamification-rule/gamification-rule.component';
import { GamificationRuleService } from './gamification-rule/gamification-rule.service';
import { ReadMoreComponent } from './read-more/read-more.component';
import { NomoreDataComponent } from './nomore-data/nomore-data.component';
import { BaseService } from '../shared-service/base.service';
import { WidgetContainerComponent } from './widget/widget-container.component';
import { WidgetDirective } from './widget/widget.directive';
import { SharingPanelComponent } from './sharing-panel/sharing-panel.component';
import { VisibilityFilterComponent } from './visibility-filter/visibility-filter.component';
import { UserListComponent } from './user-list/user-list.component';
import { fileUploadAttachementComponent } from './file-upload-attachement/file-upload-attachement.component';
import { EsignComponent } from './e-sign/esign.component';
import { LearningCardListComponent } from './learning-card-list/learning-card-list.component';
import { LearningCardComponent } from './learning-card/learning-card.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { LearningCardAllComponent } from './learning-card-all/learning-card-all.component';
import { ResetNodeComponent } from './reset-node/reset-node.component';
import { DynamicFieldComponent } from './dynamic-field/dynamic-field.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FileuploadParamPipe } from './dynamic-field/fileupload-param.pipe';
import { MultiselectSelectedItemPipe } from './dynamic-field/multiselect-selected-item.pipe';
import { FieldPermissionPipe } from './dynamic-field/field-permission.pipe';
import { SearchCardComponent } from '../../app/shared-components/search-card/search-card.component';
import { DynamicFieldLearningComponent } from './dynamic-field-learning/dynamic-field-learning.component';
import { ViewMoreLikeThisComponent } from './view-more-like-this/view-more-like-this.component';
import { ViewMoreLikeThisService } from './view-more-like-this/view-more-like-this.service';
import { SearchCardPipe } from './search-card/search-card.pipe';
import { SuggestionsComponent } from './suggestions/suggestions.component';
import { ShareWallComponent } from './share-wall/share-wall.component';


@NgModule({
    imports: [
        CommonModule,
        QuillModule,
        FormsModule,
        AngularMultiSelectModule
    ],
    declarations: [        
        ErrorViewComponent,
        FileUploadComponent,
        CommentComponent,
        GamificationRuleComponent,
        ReadMoreComponent,
        NomoreDataComponent,
        EscapePipe,
        SafeHtmlPipe,
        LoadingDirective,
        WidgetContainerComponent,
        WidgetDirective,
        LoaderComponent,
        SharingPanelComponent,
        VisibilityFilterComponent,
        UserListComponent,
        fileUploadAttachementComponent,
        EsignComponent,
        LearningCardListComponent,
        LearningCardComponent,
        SideMenuComponent,
        FilterPanelComponent,
        LearningCardAllComponent,
        ResetNodeComponent,
        DynamicFieldComponent,
        FileuploadParamPipe,
        MultiselectSelectedItemPipe,
        FieldPermissionPipe,
        SearchCardComponent,
        DynamicFieldLearningComponent,
        ViewMoreLikeThisComponent,
        SearchCardPipe,
        SuggestionsComponent,
        ShareWallComponent
    ],
    providers: [
        FileUploadService,
        CommentService,
        GamificationRuleService,
        SideMenuComponent,
        ViewMoreLikeThisService
  ],
    entryComponents: [
        SharingPanelComponent
    ],
    exports: [
        ErrorViewComponent,
        FileUploadComponent,
        CommentComponent,
        GamificationRuleComponent,
        ReadMoreComponent,
        NomoreDataComponent,
        EscapePipe,
        SafeHtmlPipe,
        LoadingDirective,
        WidgetContainerComponent,
        LoaderComponent,
        SharingPanelComponent,
        VisibilityFilterComponent,
        UserListComponent,
        EsignComponent,
        LearningCardListComponent,
        LearningCardComponent,
        SideMenuComponent,
        FilterPanelComponent,
        LearningCardAllComponent,
        ResetNodeComponent,
        DynamicFieldComponent,
        SearchCardComponent,
        DynamicFieldLearningComponent,
        ViewMoreLikeThisComponent,
        SearchCardPipe,
        SuggestionsComponent,
        ShareWallComponent
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SharedComponentModule {
    constructor(private bs:BaseService) {
        this.bs.log('info',"Loaded SharedComponentModule");
    }
}
